import { useMemo, useState } from 'react';

import { useShowBackerInfo } from '@givebacks/api/backer';
import { useBreakPoints, usePlatformService } from 'core';
import { NavLink } from 'react-router-dom';
import { Anchor, Center, ImageMantine } from 'ui';

import { OnlineShoppingDrawer } from '../../../components/Drawers/OnlineShoppingDrawer';
import chromeExtension from '../../../utils/chromeExtension';
import { WaysToGiveBackLayout } from './WaysToGiveBack.Layout';

const ShoppingCartGIF = () => {
  const { isMediumScreen } = useBreakPoints();
  return (
    <Center>
      <ImageMantine
        radius={isMediumScreen ? 20 : 'sm'}
        style={{ boxShadow: '0px 14px 24px 0px #BFCCF0' }}
        maw={400}
        src={
          isMediumScreen
            ? 'https://s3.amazonaws.com/com.givebacks.public/images/extensions/mobile-activate.gif'
            : 'https://s3.amazonaws.com/com.givebacks.public/images/extensions/desktop-activate.gif'
        }
      />
    </Center>
  );
};

const ShopOnline = () => {
  const { data: backer } = useShowBackerInfo();
  const Platform = usePlatformService();
  const { isDesktop, isMobile } = useBreakPoints();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    if (Platform.OS === 'native') setIsModalOpen(true);
    else {
      chromeExtension.download();
    }
  };

  const successMessage = useMemo(() => {
    const isMobileExtensionEnabled = backer?.home?.mobile_extension_enabled;
    const isChromeExtensionEnabled = backer?.home?.chrome_extension_enabled;

    const isExtensionInstalled =
      (isDesktop && isChromeExtensionEnabled) || (isMobile && isMobileExtensionEnabled);

    if (isExtensionInstalled) {
      return 'Extension Installed!';
    } else {
      return undefined;
    }
  }, [
    backer?.home?.chrome_extension_enabled,
    backer?.home?.mobile_extension_enabled,
    isDesktop,
    isMobile,
  ]);

  return (
    <>
      <WaysToGiveBackLayout
        title="Shop Online"
        cta={successMessage ? undefined : { label: 'Get the Extension', onClick: handleClick }}
        tagline="Help earn donations for your causes when you shop online."
        copy={
          <>
            Add the Givebacks extension to your Safari or Chrome browser and earn donations for{' '}
            <Anchor component={NavLink} to="/causes">
              your favorite causes
            </Anchor>{' '}
            at no extra cost to you when you shop at participating online stores
          </>
        }
        howItWorks={{
          listItems: [
            'The Givebacks extension will pop up when you shop online or search on Google.',
            "Click 'Activate' on the extension before you check out",
            `The brand will donate a portion of your purchase to your favorite causes!`,
          ],
          content: <ShoppingCartGIF />,
        }}
        successMessage={successMessage}
      />
      <OnlineShoppingDrawer drawerControl={[isModalOpen, setIsModalOpen]} />
    </>
  );
};

export { ShopOnline };
